import axios from "axios";
import { config } from "@/config";
import { ImovelIPTU, GuiaIPTU, TipoGuia } from "@/types";
import { apiPortal } from "./api";
import { apiPublica } from "./apiPublica";

// const apiPublica = axios.create({
//   baseURL: config.apiUrl,
//   headers: {
//     "Content-Type": "application/json",
//   },
// });

export const buscarImoveisPublicoRequest = async (props:{cpfCnpj: string, recaptchaToken: string}) => {
  const { data } = await apiPublica.post(`/api/publico/iptu/imoveis`, props);
  return data;
};

export const buscarGuiasPublicoRequest = async (imovelId: string, tipoGuia: TipoGuia): Promise<GuiaIPTU[]> => {
  const { data } = await apiPublica.get(`/api/publico/iptu/imoveis/${imovelId}/guias`, {
    params: { tipoGuia },
  });
  return data;
};

export const emitirGuiaPublicoRequest = async (guiaId: string, imovelId: string): Promise<any> => {
  const { data } = await apiPublica.get(`/api/publico/iptu/guias/${guiaId}/emitir?imovelId=${imovelId}`);
  return data;
};

export const buscarImoveisRequest = async (cpfCnpj: string): Promise<ImovelIPTU[]> => {
    const { data } = await apiPortal.post(`/api/portal/iptu/imoveis`, {cpfCnpj});
    return data;
};

export const buscarGuiasRequest = async (imovelId: string, tipoGuia: TipoGuia): Promise<GuiaIPTU[]> => {
  console.log('tipoguia', tipoGuia)
    const { data } = await apiPortal.get(`/api/portal/iptu/imoveis/${imovelId}/guias`, {
      params: { tipoGuia }
    });
    return data;

};

export const emitirGuiaRequest = async (guiaId: string): Promise<any> => {
    const { data } = await apiPortal.get(`/api/portal/iptu/guias/${guiaId}/emitir`);
    return data;
};
